module.exports = __webpack_public_path__ + "img/chevron-compact-up.394776a2.svg";